import React from "react";
import { Button as MatButton, makeStyles, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    border: 0,
    borderRadius: "0.1rem",
    minHeight: 50,
    fontSize: "1.1rem",
    fontFamily: "Ride",
    fontWeight: "400",
    textTransform: "none",
    padding: "5px 15px 5px 15px",
    "&:hover.Mui-disabled": {
      backgrundColor: "grey",
    },
    boxShadow: "inset 0 0.2rem 0.4rem 0 rgba(0,0,0,0.1)",
    background: theme.palette.primary.main,
    color: theme.palette.primary.text,
    "&:hover": {
      background: theme.palette.primary.hover,
      fontWeight: "700",
      "&.Mui-disabled": {
        backgroundColor: theme.hertzColors.disabled,
      },
    },
    "&:disabled": {
      fontWeight: "700",
      background: theme.hertzColors.disabled,
      color: "white",
    },
  },
  grey: {
    background: "#f3f4f8",
    borderColor: "#f3f4f8",
    color: theme.hertzColors.ninetyBlack,
    border: `1px solid ${theme.hertzColors.ninetyBlack}`,
    "&:hover": {
      background: theme.hertzColors.ninetyBlack,
      color: "white",
    },
    "&:disabled": {
      borderColor: theme.hertzColors.sixtyBlack,
    },
  },
  loading: {
    color: theme.palette.primary.text,
  },
}));

const Button = ({ fullWidth, title, disabled, color, loading, children, ...rest }) => {
  const classes = useStyles();
  let style = `${classes.root}`;
  style = `${style} ${classes[color]}`;

  return (
    <MatButton className={style} fullWidth={fullWidth} disabled={disabled} {...rest}>
      {loading ? "Loading..." : title}
      {loading ? <></> : children}
      {loading ? <CircularProgress className={classes.loading} size={20} /> : ""}
    </MatButton>
  );
};

export default Button;
